import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h1 mat-dialog-title>Operazione non disponibile</h1>
    <div mat-dialog-content>
      Questa operazione non è disponibile dall'applicazione. Utilizza Brain da un computer per procedere.
    </div>
    <div mat-dialog-actions style="display: flex; justify-content: flex-end;">
      <button mat-flat-button color="primary" mat-dialog-close>Chiudi</button>
    </div>
  `
})
export class DialogNonDisponibileAppComponent {}
